// import { LeaderboardDataReturn } from '@freeplay/shared-code';
import React from "react";
import { View, ScrollView, SafeAreaView, Dimensions } from "react-native";
import { LeaderboardEntry } from "./LeaderboardEntry";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { GameLeaderboardDataReturn } from "@freeplay/shared-code";

export interface LeaderboardProps {
    /**
     * Show these real entries.
     */
    // leaderboardData?: LeaderboardDataReturn[];
    leaderboardData: GameLeaderboardDataReturn[];
    /**
     * playerId for highlighting row
     */
    playerId?: number;
    // TestID for testing useing jester
    TestID?: string;
}
export const Leaderboard: React.FC<LeaderboardProps> = ({ leaderboardData, playerId, TestID }) => {
    const styles = useDynamicStyles(generateStyles);

    return (
        <View testID={TestID} style={styles.container}>
            <View style={styles.container}>
                <SafeAreaView style={styles.containerTest}>
                    <ScrollView
                        style={styles.scrollView}
                        invertStickyHeaders={true}
                        stickyHeaderIndices={playerId ? [playerId] : []}
                    >
                        {leaderboardData.map((entry: GameLeaderboardDataReturn, i: number) => {
                            return (
                                <LeaderboardEntry
                                    lbData={entry}
                                    key={`entry-number-${i}`}
                                    place={i + 1}
                                    loggedInPlayerRow={entry.playerId === playerId}
                                />
                            );
                        })}
                    </ScrollView>
                </SafeAreaView>
            </View>
        </View>
    );
};

const generateStyles = () => {
    return EStyleSheet.create({
        container: {
            width: "100%",
            flex: 1,
        },
        containerTest: {
            flex: 1,
            height: Dimensions.get("window").height - 120,
        },
        scrollView: {
            flex: 1,
            paddingHorizontal: 10,
        },
    });
};
